import React from 'react';
import type { V2Route } from '../units/types';

/** この担当が新UIで作り直した画面の経路。作り終えたものから足す（足すまでは旧画面が枠の中に出る） */
const routes: V2Route[] = [
  // 旧バナー広告画面の場所。機能は新UIのバナー生成（/test-ui/banner）にまとめた
  { path: 'ads/banner', Component: React.lazy(() => import('./ToBannerPage')) },
];

export default routes;
